

// search layout set
export function searchOn() {
    document.querySelector(".mainsearchbox").style.left = '0px'
    document.querySelector(".onoffbtn").style.left = '300px'
    document.querySelector(".onoffbtn").innerHTML = "<"
    document.querySelector(".svgBox").style.marginLeft = "300px"
}
// search layout set
export function searchOff() {
    document.querySelector(".svgBox").style.marginLeft = "0px"
    document.querySelector(".mainsearchbox").style.left = '-300px'
    document.querySelector(".onoffbtn").style.left = '0px'
    document.querySelector(".onoffbtn").innerHTML = ">"
}


// next Prev floor btn data create
export function AllFloor(data, g) {
    let x = []
    let type = []

    data.forEach(d => {
        if (g.nodePoint[`${d.x},${d.y},${d.z}`].point.type === "Elevator") {
            // 
            type.push(d.z)
        }
        x.push(d.z)
    })
    if (type.length > 0) {
        x = []
        x.push(type[0])
        x.push(type[type.length - 1])
    }
    console.log(x, type, "datasss");
    let y0 = []
    if (type.length > 0) {
        type.forEach((d, i) => {
            if (y0.length > 0) {
                if (type[i - 1] == d) {
                    y0.push(d)
                }
                if (type.length - 1 == i) {
                    y0.push(d)
                }
            } else {
                y0.push(d)
            }
        })
    }
    console.log(y0, "y0");
    if (y0.length > 0) {
        return [...y0]
    }
    let y = []
    x.forEach((d, i) => {
        if (y.length > 0) {
            if (y[y.length - 1] != d) {
                y.push(d)
            }
        } else {
            y.push(d)
        }
    })
    console.log(y, "xxxxxxxxxx");
    let uniq = new Set(x)
    return [...y]
}


// filter store ads data
export function FilterAdd(data, g) {
    let x = []
    data.map(d => {
        if (g.nodePoint[`${d.x},${d.y},${d.z}`]) {
            let find = g.nodePoint[`${d.x},${d.y},${d.z}`]
            if (find?.point?.colleague) {
                find?.point?.colleague.forEach(a => {
                    if (g.nodePoint[`${a.x},${a.y},${a.z}`]) {
                        if (g.nodePoint[`${a.x},${a.y},${a.z}`]?.point?.LocationName) {
                            let text = g.nodePoint[`${a.x},${a.y},${a.z}`]?.point?.LocationName?.text.trim()
                            console.log(text, " this is the location");
                            let yeHai = text[0]?.toLowerCase() === "a" || text[0]?.toLowerCase() === "b" || text[0]?.toLowerCase() === "c" || text[0]?.toLowerCase() === "d"
                            if (text && yeHai) {
                                x.push(g.nodePoint[`${a.x},${a.y},${a.z}`]?.point)
                                // x.push(g.nodePoint[`${a.x},${a.y},${a.z}`]?.point.LocationName.text)
                            }
                        }
                    }
                })
            }
        }
    })
    return x
}


// if store ads than show ads text
export function ShowTextWhat(data, arr) {
    let { x, y, z } = data
    let find = arr?.find(d => d.x === x && d.y == y && d.z === z)

    if (find) {
        return "Ads"
    } else {
        return data.LocationName.text
    }
}

// responsive layout set
export function responsive() {
    if (document.querySelector(".portrait")) {
        if (window.innerWidth > window.innerHeight) {
            document.querySelector(".portrait").style.display = "none"
            document.querySelector(".landscape").style.display = "block"
        } else {
            document.querySelector(".landscape").style.display = "none"
            document.querySelector(".portrait").style.display = "block"
        }
        window.addEventListener("resize", () => {
            if (window.innerWidth > window.innerHeight) {
                document.querySelector(".portrait").style.display = "none"
                document.querySelector(".landscape").style.display = "block"
            } else {
                document.querySelector(".landscape").style.display = "none"
                document.querySelector(".portrait").style.display = "block"
            }
        })
    }
}

export function goFullScreen() {
    var elem = document.documentElement
    if (!document.fullscreenElement) {
        console.log("kuch ho raha hai ");
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
            elem.msRequestFullscreen();
        }
    }
}

// Mall name Filter
export function FilterValue(e, g, prarambh) {
    if (prarambh === "end") {
        g.setEndSearchInput({ name: e.target.value })
        let x = ShowResult(e, g)
        g.setDisplayEndPointResult(x)
    } else if (prarambh == "start") {
        g.setStartSearchInput({ name: e.target.value })
        let x = ShowResult(e, g)
        g.setDisplayEndPointResult(null)
        g.setDisplayStartPointResult(x)
    } else {
        g.setEndSearchInput({ name: e.target.value })
        let x = ShowResult(e, g)
        g.setDisplayStartPointResult(null)
        g.setDisplayEndPointResult(x)
    }
}

// 
export function ShowResult(e, data) {
    let x = []
    Object.values(data.nodePoint).map(d => {
        if (d.point.LocationName) {
            if ((d.point.LocationName.text.toLowerCase()).match(e.target.value.toLowerCase())) {
                x.push(d.point)
            }
        }
    })

    // let uniq = [...new Set(x)]
    let uniq = x.filter((value, index, self) =>
        index === self.findIndex((t) => (
            t.LocationName.text === value.LocationName.text
        ))
    )

    return uniq
}

export function HideDropdown() {
    let x = document.querySelectorAll('.Dropmenu')
    for (let index = 0; index < x.length; index++) {
        const element = x[index];
        element.style.padding = "0px"
        element.style.height = 0 + "px"
        element.style.width = 0 + "px"

    }
}